<div>
  <div class="form-section">
    <ng-container *ngIf="caseData$ | async as caseData">

      <ng-container [ngSwitch]="caseData?.clientInformation?.case_type?.name">

        <ng-container *ngSwitchCase="'Lien'">
          <form>
            <div class="row">
              <div class="col-4">
                <div class="form-group">
                  <label for="adj">ADJ</label>
                  <input type="text" class="form-control" id="adj" />
                </div>
              </div>
              <div class="col-4">
                <div class="form-group">
                  <label for="number_of_liens">Number of Liens</label>
                  <input type="number" class="form-control" id="number_of_liens" />
                </div>
              </div>
              <div class="col-4">
                <div class="form-group">
                  <label for="budget">Budget</label>
                  <input type="number" class="form-control" id="budget" />
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-4">
                <div class="form-group">
                  <label for="flags">Flags</label>
                  <select type="text" class="form-control" id="flags">
                    <option value="">Select Flags</option>
                    <ng-container *ngFor="let flag of caseTypeFlags$ | async">
                      <option [value]="flag.id">{{ flag.name }}</option>
                    </ng-container>
                  </select>
                </div>
              </div>
              <div class="col-4">
                <div class="form-group">
                  <label for="case_manager">Case Manager</label>
                  <select type="text" class="form-control" id="case_manager">
                    <option value="">Select Case Manager</option>
                  </select>
                </div>
              </div>
              <div class="col-4">
                <div class="form-group">
                  <label for="attachment">Files/Attachments</label>
                  <input type="file" class="form-control" id="attachment" placeholder="No file selected">
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-4">
                <div class="form-group">
                  <label for="aka">AKA</label>
                  <select type="text" class="form-control" id="aka">
                    <option value="">Select AKA</option>
                  </select>
                </div>
              </div>
            </div>
          </form>
        </ng-container>

        <ng-container *ngSwitchCase="'SIU Claimant'">
          <form>
            <div class="row">
              <div class="col-4">
                <div class="form-group">
                  <label for="adj">ADJ</label>
                  <input type="text" class="form-control" id="adj" />
                </div>
              </div>
              <div class="col-4">
                <div class="form-group">
                  <label for="budget">Budget</label>
                  <input type="number" class="form-control" id="budget" />
                </div>
              </div>
              <div class="col-4">
                <div class="form-group">
                  <label for="flags">Flags</label>
                  <select type="text" class="form-control" id="flags">
                    <option value="">Select Flags</option>
                  </select>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-4">
                <div class="form-group">
                  <label for="case_manager">Case Manager</label>
                  <select type="text" class="form-control" id="case_manager">
                    <option value="">Select Case Manager</option>
                  </select>
                </div>
              </div>
              <div class="col-4">
                <div class="form-group">
                  <label for="attachment">Files/Attachments</label>
                  <input type="file" class="form-control" id="attachment" placeholder="No file selected">
                </div>
              </div>
              <div class="col-4">
                <div class="form-group">
                  <label for="gdrive_folder_access">Access to Draft Folder on GDrive</label>
                  <select type="text" class="form-control" id="gdrive_folder_access">
                    <option value="">Select Access</option>
                    <option value="yes">Yes</option>
                    <option value="no">No</option>
                  </select>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-4">
                <div class="form-group">
                  <label for="depo_date">Depo Date</label>
                  <input type="text" class="form-control" id="depo_date" jDate />
                </div>
              </div>

              <div class="col-4">
                <div class="form-group">
                  <label for="depo_time">Depo Time</label>
                  <input type="text" class="form-control" id="depo_time" mask="00:00:00" />
                </div>
              </div>

              <div class="col-4">
                <div class="form-group">
                  <label for="depo_location">Depo Location</label>
                  <input type="text" class="form-control" id="depo_location" />
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-4">
                <div class="form-group">
                  <label for="origin">Origin</label>
                  <input type="text" class="form-control" id="origin"/>
                </div>
              </div>

              <div class="col-4">
                <div class="form-group">
                  <label for="notes_instructions">Notes & Instructions</label>
                  <textarea type="text" class="form-control" id="notes_instructions">
                  </textarea>
                </div>
              </div>

              <div class="col-4">
                <div class="form-group">
                  <label for="scheduling_notes">Scheduling Notes</label>
                  <textarea type="text" class="form-control" id="scheduling_notes">
                  </textarea>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-4">
                <div class="form-group">
                  <label for="admin_notes">Admin Notes</label>
                  <textarea type="text" class="form-control" id="admin_notes">
                  </textarea>
                </div>
              </div>

              <div class="col-4">
                <div class="form-group">
                  <label for="referral_source">Referral Source</label>
                  <select type="text" class="form-control" id="referral_source">
                    <option value="">Select Referral Source</option>
                  </select>
                </div>
              </div>

              <div class="col-4">
                <div class="form-group">
                  <input type="checkbox" name="success_story" id="success_story">
                  <label for="success_story" class="ml-1">Success Story</label>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-4">
                <div class="form-group">
                  <label for="estimated_claims_savings">Estimated Claims Savings</label>
                  <input type="numeric" class="form-control" id="estimated_claims_savings"/>
                </div>
              </div>

              <div class="col-4">
                <div class="form-group">
                  <label for="success_story_summary">Success Story Summary</label>
                  <textarea type="text" class="form-control" id="success_story_summary">
                  </textarea>
                </div>
              </div>

              <div class="col-4">
                <div class="form-group">
                  <input type="checkbox" name="arrest" id="arrest">
                  <label for="arrest" class="ml-1">Arrest</label>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-4">
                <div class="form-group">
                  <label for="carrier_name">Carrier Name</label>
                  <input type="text" class="form-control" id="carrier_name"/>
                </div>
              </div>

              <div class="col-4">
                <div class="form-group">
                  <input type="checkbox" name="case_charged" id="case_charged">
                  <label for="case_charged" class="ml-1">Case Charged</label>
                </div>
              </div>

              <div class="col-4">
                <div class="form-group">
                  <label for="case_synopsis">Case Synopsis</label>
                  <textarea type="text" class="form-control" id="case_synopsis">
                  </textarea>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-4">
                <div class="form-group">
                  <label for="closing_summary_date">Closing Summary Date</label>
                  <input type="text" class="form-control" id="closing_summary_date" jDate/>
                </div>
              </div>

              <div class="col-4">
                <div class="form-group">
                  <label for="last_invoiced">Last Invoiced</label>
                  <input type="text" class="form-control" id="last_invoiced" jDate/>
                </div>
              </div>

              <div class="col-4">
                <div class="form-group">
                  <label for="last_update_to_client">Last Update to Client</label>
                  <input type="text" class="form-control" id="last_update_to_client" jDate/>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-4">
                <div class="form-group">
                  <label for="depo_questions_to_da">Depo Questions to DA</label>
                  <textarea type="text" class="form-control" id="depo_questions_to_da">
                  </textarea>
                </div>
              </div>

              <div class="col-4">
                <div class="form-group">
                  <input type="checkbox" name="client_cms_flag_request" id="client_cms_flag_request">
                  <label for="client_cms_flag_request" class="ml-1">Client CMS Flag Request</label>
                </div>
              </div>

              <div class="col-4">
                <div class="form-group">
                  <input type="checkbox" name="client_cms_flagged" id="client_cms_flagged">
                  <label for="client_cms_flagged" class="ml-1">Client CMS Flagged</label>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-4">
                <div class="form-group">
                  <label for="resonable_belief">Reasonable Belief</label>
                  <select type="text" class="form-control" id="reasonable_belief">
                    <option value="">Select Reasonable Belief</option>
                    <option value="yes">Yes</option>
                    <option value="no">No</option>
                  </select>
                </div>
              </div>

              <div class="col-4">
                <div class="form-group">
                  <label for="sfc_fd_1">SFC/FD-1</label>
                  <input type="file" class="form-control" name="sfc_fd_1" id="sfc_fd_1">
                </div>
              </div>

              <div class="col-4">
                <div class="form-group">
                  <label for="lea_county">LEA County (DA/DOI)</label>
                  <input type="text" class="form-control" id="lea_county"/>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-4">
                <div class="form-group">
                  <label for="da_acknowledgement">DA Acknowledgement</label>
                  <input type="text" class="form-control" id="da_acknowledgement" jDate/>
                </div>
              </div>

              <div class="col-4">
                <div class="form-group">
                  <label for="da_request_date">DA Request Date</label>
                  <input type="text" class="form-control" id="da_request_date" jDate/>
                </div>
              </div>

              <div class="col-4">
                <div class="form-group">
                  <label for="da_request_sent_back">DA Request Sent Back</label>
                  <input type="text" class="form-control" id="da_request_sent_back" jDate/>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-4">
                <div class="form-group">
                  <label for="da_declination_date">DA Declination Date</label>
                  <input type="text" class="form-control" id="da_declination_date" jDate/>
                </div>
              </div>

              <div class="col-4">
                <div class="form-group">
                  <label for="doi_acknowledgement">DOI Acknowledgement</label>
                  <input type="text" class="form-control" id="doi_acknowledgement" jDate/>
                </div>
              </div>

              <div class="col-4">
                <div class="form-group">
                  <label for="cdi_case_number">CDI Case Number</label>
                  <input type="text" class="form-control" id="cdi_case_number"/>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-4">
                <div class="form-group">
                  <label for="doi_request_date">DOI Request Date</label>
                  <input type="text" class="form-control" id="doi_request_date" jDate/>
                </div>
              </div>

              <div class="col-4">
                <div class="form-group">
                  <label for="doi_request_sent_back">DOI Request Sent Back</label>
                  <input type="text" class="form-control" id="doi_request_sent_back" jDate/>
                </div>
              </div>

              <div class="col-4">
                <div class="form-group">
                  <label for="doi_declination_date">DOI Declination Date</label>
                  <input type="text" class="form-control" id="doi_declination_date" jDate/>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-4">
                <div class="form-group">
                  <input type="checkbox" name="dr_in_progress" id="dr_in_progress">
                  <label for="dr_in_progress" class="ml-1">D/R in Progress</label>
                </div>
              </div>

              <div class="col-4">
                <div class="form-group">
                  <input type="checkbox" name="dr_to_lea" id="dr_to_lea">
                  <label for="dr_to_lea" class="ml-1">D/R to LEA</label>
                </div>
              </div>

              <div class="col-4">
                <div class="form-group">
                  <label for="convicted">Convicted</label>
                  <select type="text" class="form-control" id="convicted">
                    <option value="">Select Convicted</option>
                    <option value="yes">Yes</option>
                    <option value="no">No</option>
                  </select>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-4">
                <div class="form-group">
                  <label for="restitution_awarded">Restitution Awarded</label>
                  <select type="text" class="form-control" id="restitution_awarded">
                    <option value="">Select Restitution Awarded</option>
                    <option value="yes">Yes</option>
                    <option value="no">No</option>
                  </select>
                </div>
              </div>

              <div class="col-4">
                <div class="form-group">
                  <label for="restitution_awarded_amount">Restitution Awarded Amount</label>
                  <input type="numeric" class="form-control" id="restitution_awarded_amount"/>
                </div>
              </div>

              <div class="col-4">
                <div class="form-group">
                  <label for="aka">AKA</label>
                  <select type="text" class="form-control" id="aka">
                    <option value="">Select AKA</option>
                  </select>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-4">
                <div class="form-group">
                  <label for="assigned_da_firm">Assigned DA Firm</label>
                  <input type="text" class="form-control" id="assigned_da_firm"/>
                </div>
              </div>
            </div>
          </form>
        </ng-container>

        <ng-container *ngSwitchCase="'SIU Premium'">
          <form>
            <div class="row">
              <div class="col-4">
                <div class="form-group">
                  <label for="budget">Budget</label>
                  <input type="number" class="form-control" id="budget" />
                </div>
              </div>
              <div class="col-4">
                <div class="form-group">
                  <label for="flags">Flags</label>
                  <select type="text" class="form-control" id="flags">
                    <option value="">Select Flags</option>
                  </select>
                </div>
              </div>
              <div class="col-4">
                <div class="form-group">
                  <label for="case_manager">Case Manager</label>
                  <select type="text" class="form-control" id="case_manager">
                    <option value="">Select Case Manager</option>
                  </select>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-4">
                <div class="form-group">
                  <label for="attachment">Files/Attachments</label>
                  <input type="file" class="form-control" id="attachment" placeholder="No file selected">
                </div>
              </div>
              <div class="col-4">
                <div class="form-group">
                  <label for="gdrive_folder_access">Access to Draft Folder on GDrive</label>
                  <select type="text" class="form-control" id="gdrive_folder_access">
                    <option value="">Select Access</option>
                    <option value="yes">Yes</option>
                    <option value="no">No</option>
                  </select>
                </div>
              </div>
              <div class="col-4">
                <div class="form-group">
                  <label for="depo_date">Depo Date</label>
                  <input type="text" class="form-control" id="depo_date" jDate />
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-4">
                <div class="form-group">
                  <label for="origin">Origin</label>
                  <input type="text" class="form-control" id="origin"/>
                </div>
              </div>

              <div class="col-4">
                <div class="form-group">
                  <label for="notes_instructions">Notes & Instructions</label>
                  <textarea type="text" class="form-control" id="notes_instructions">
                  </textarea>
                </div>
              </div>

              <div class="col-4">
                <div class="form-group">
                  <label for="scheduling_notes">Scheduling Notes</label>
                  <textarea type="text" class="form-control" id="scheduling_notes">
                  </textarea>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-4">
                <div class="form-group">
                  <label for="admin_notes">Admin Notes</label>
                  <textarea type="text" class="form-control" id="admin_notes">
                  </textarea>
                </div>
              </div>

              <div class="col-4">
                <div class="form-group">
                  <label for="referral_source">Referral Source</label>
                  <select type="text" class="form-control" id="referral_source">
                    <option value="">Select Referral Source</option>
                  </select>
                </div>
              </div>

              <div class="col-4">
                <div class="form-group">
                  <input type="checkbox" name="success_story" id="success_story">
                  <label for="success_story" class="ml-1">Success Story</label>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-4">
                <div class="form-group">
                  <label for="estimated_claims_savings">Estimated Claims Savings</label>
                  <input type="numeric" class="form-control" id="estimated_claims_savings"/>
                </div>
              </div>

              <div class="col-4">
                <div class="form-group">
                  <label for="success_story_summary">Success Story Summary</label>
                  <textarea type="text" class="form-control" id="success_story_summary">
                  </textarea>
                </div>
              </div>

              <div class="col-4">
                <div class="form-group">
                  <input type="checkbox" name="arrest" id="arrest">
                  <label for="arrest" class="ml-1">Arrest</label>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-4">
                <div class="form-group">
                  <label for="carrier_name">Carrier Name</label>
                  <input type="text" class="form-control" id="carrier_name"/>
                </div>
              </div>

              <div class="col-4">
                <div class="form-group">
                  <input type="checkbox" name="case_charged" id="case_charged">
                  <label for="case_charged" class="ml-1">Case Charged</label>
                </div>
              </div>

              <div class="col-4">
                <div class="form-group">
                  <label for="case_synopsis">Case Synopsis</label>
                  <textarea type="text" class="form-control" id="case_synopsis">
                  </textarea>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-4">
                <div class="form-group">
                  <label for="closing_summary_date">Closing Summary Date</label>
                  <input type="text" class="form-control" id="closing_summary_date" jDate/>
                </div>
              </div>

              <div class="col-4">
                <div class="form-group">
                  <label for="last_invoiced">Last Invoiced</label>
                  <input type="text" class="form-control" id="last_invoiced" jDate/>
                </div>
              </div>

              <div class="col-4">
                <div class="form-group">
                  <label for="last_update_to_client">Last Update to Client</label>
                  <input type="text" class="form-control" id="last_update_to_client" jDate/>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-4">
                <div class="form-group">
                  <label for="depo_questions_to_da">Depo Questions to DA</label>
                  <textarea type="text" class="form-control" id="depo_questions_to_da">
                  </textarea>
                </div>
              </div>

              <div class="col-4">
                <div class="form-group">
                  <input type="checkbox" name="client_cms_flag_request" id="client_cms_flag_request">
                  <label for="client_cms_flag_request" class="ml-1">Client CMS Flag Request</label>
                </div>
              </div>

              <div class="col-4">
                <div class="form-group">
                  <input type="checkbox" name="client_cms_flagged" id="client_cms_flagged">
                  <label for="client_cms_flagged" class="ml-1">Client CMS Flagged</label>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-4">
                <div class="form-group">
                  <label for="resonable_belief">Reasonable Belief</label>
                  <select type="text" class="form-control" id="reasonable_belief">
                    <option value="">Select Reasonable Belief</option>
                    <option value="yes">Yes</option>
                    <option value="no">No</option>
                  </select>
                </div>
              </div>

              <div class="col-4">
                <div class="form-group">
                  <label for="sfc_fd_1">SFC/FD-1</label>
                  <input type="file" class="form-control" name="sfc_fd_1" id="sfc_fd_1">
                </div>
              </div>

              <div class="col-4">
                <div class="form-group">
                  <label for="lea_county">LEA County (DA/DOI)</label>
                  <input type="text" class="form-control" id="lea_county"/>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-4">
                <div class="form-group">
                  <label for="da_acknowledgement">DA Acknowledgement</label>
                  <input type="text" class="form-control" id="da_acknowledgement" jDate/>
                </div>
              </div>

              <div class="col-4">
                <div class="form-group">
                  <label for="da_request_date">DA Request Date</label>
                  <input type="text" class="form-control" id="da_request_date" jDate/>
                </div>
              </div>

              <div class="col-4">
                <div class="form-group">
                  <label for="da_request_sent_back">DA Request Sent Back</label>
                  <input type="text" class="form-control" id="da_request_sent_back" jDate/>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-4">
                <div class="form-group">
                  <label for="da_declination_date">DA Declination Date</label>
                  <input type="text" class="form-control" id="da_declination_date" jDate/>
                </div>
              </div>

              <div class="col-4">
                <div class="form-group">
                  <label for="doi_acknowledgement">DOI Acknowledgement</label>
                  <input type="text" class="form-control" id="doi_acknowledgement" jDate/>
                </div>
              </div>

              <div class="col-4">
                <div class="form-group">
                  <label for="cdi_case_number">CDI Case Number</label>
                  <input type="text" class="form-control" id="cdi_case_number"/>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-4">
                <div class="form-group">
                  <label for="doi_request_date">DOI Request Date</label>
                  <input type="text" class="form-control" id="doi_request_date" jDate/>
                </div>
              </div>

              <div class="col-4">
                <div class="form-group">
                  <label for="doi_request_sent_back">DOI Request Sent Back</label>
                  <input type="text" class="form-control" id="doi_request_sent_back" jDate/>
                </div>
              </div>

              <div class="col-4">
                <div class="form-group">
                  <label for="doi_declination_date">DOI Declination Date</label>
                  <input type="text" class="form-control" id="doi_declination_date" jDate/>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-4">
                <div class="form-group">
                  <input type="checkbox" name="dr_in_progress" id="dr_in_progress">
                  <label for="dr_in_progress" class="ml-1">D/R in Progress</label>
                </div>
              </div>

              <div class="col-4">
                <div class="form-group">
                  <input type="checkbox" name="dr_to_lea" id="dr_to_lea">
                  <label for="dr_to_lea" class="ml-1">D/R to LEA</label>
                </div>
              </div>

              <div class="col-4">
                <div class="form-group">
                  <label for="convicted">Convicted</label>
                  <select type="text" class="form-control" id="convicted">
                    <option value="">Select Convicted</option>
                    <option value="yes">Yes</option>
                    <option value="no">No</option>
                  </select>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-4">
                <div class="form-group">
                  <label for="restitution_awarded">Restitution Awarded</label>
                  <select type="text" class="form-control" id="restitution_awarded">
                    <option value="">Select Restitution Awarded</option>
                    <option value="yes">Yes</option>
                    <option value="no">No</option>
                  </select>
                </div>
              </div>

              <div class="col-4">
                <div class="form-group">
                  <label for="restitution_awarded_amount">Restitution Awarded Amount</label>
                  <input type="numeric" class="form-control" id="restitution_awarded_amount"/>
                </div>
              </div>
            </div>

          </form>
        </ng-container>

        <ng-container *ngSwitchCase="'SIU Provider'">
          <form>
            <div class="row">
              <div class="col-4">
                <div class="form-group">
                  <label for="budget">Budget</label>
                  <input type="number" class="form-control" id="budget" />
                </div>
              </div>
              <div class="col-4">
                <div class="form-group">
                  <label for="flags">Flags</label>
                  <select type="text" class="form-control" id="flags">
                    <option value="">Select Flags</option>
                  </select>
                </div>
              </div>
              <div class="col-4">
                <div class="form-group">
                  <label for="case_manager">Case Manager</label>
                  <select type="text" class="form-control" id="case_manager">
                    <option value="">Select Case Manager</option>
                  </select>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-4">
                <div class="form-group">
                  <label for="attachment">Files/Attachments</label>
                  <input type="file" class="form-control" id="attachment" placeholder="No file selected">
                </div>
              </div>
              <div class="col-4">
                <div class="form-group">
                  <label for="gdrive_folder_access">Access to Draft Folder on GDrive</label>
                  <select type="text" class="form-control" id="gdrive_folder_access">
                    <option value="">Select Access</option>
                    <option value="yes">Yes</option>
                    <option value="no">No</option>
                  </select>
                </div>
              </div>
              <div class="col-4">
                <div class="form-group">
                  <label for="depo_date">Depo Date</label>
                  <input type="text" class="form-control" id="depo_date" jDate />
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-4">
                <div class="form-group">
                  <label for="origin">Origin</label>
                  <input type="text" class="form-control" id="origin"/>
                </div>
              </div>

              <div class="col-4">
                <div class="form-group">
                  <label for="notes_instructions">Notes & Instructions</label>
                  <textarea type="text" class="form-control" id="notes_instructions">
                  </textarea>
                </div>
              </div>

              <div class="col-4">
                <div class="form-group">
                  <label for="scheduling_notes">Scheduling Notes</label>
                  <textarea type="text" class="form-control" id="scheduling_notes">
                  </textarea>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-4">
                <div class="form-group">
                  <label for="admin_notes">Admin Notes</label>
                  <textarea type="text" class="form-control" id="admin_notes">
                  </textarea>
                </div>
              </div>

              <div class="col-4">
                <div class="form-group">
                  <label for="referral_source">Referral Source</label>
                  <select type="text" class="form-control" id="referral_source">
                    <option value="">Select Referral Source</option>
                  </select>
                </div>
              </div>

              <div class="col-4">
                <div class="form-group">
                  <input type="checkbox" name="success_story" id="success_story">
                  <label for="success_story" class="ml-1">Success Story</label>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-4">
                <div class="form-group">
                  <label for="estimated_claims_savings">Estimated Claims Savings</label>
                  <input type="numeric" class="form-control" id="estimated_claims_savings"/>
                </div>
              </div>

              <div class="col-4">
                <div class="form-group">
                  <label for="success_story_summary">Success Story Summary</label>
                  <textarea type="text" class="form-control" id="success_story_summary">
                  </textarea>
                </div>
              </div>

              <div class="col-4">
                <div class="form-group">
                  <input type="checkbox" name="arrest" id="arrest">
                  <label for="arrest" class="ml-1">Arrest</label>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-4">
                <div class="form-group">
                  <label for="carrier_name">Carrier Name</label>
                  <input type="text" class="form-control" id="carrier_name"/>
                </div>
              </div>

              <div class="col-4">
                <div class="form-group">
                  <input type="checkbox" name="case_charged" id="case_charged">
                  <label for="case_charged" class="ml-1">Case Charged</label>
                </div>
              </div>

              <div class="col-4">
                <div class="form-group">
                  <label for="case_synopsis">Case Synopsis</label>
                  <textarea type="text" class="form-control" id="case_synopsis">
                  </textarea>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-4">
                <div class="form-group">
                  <label for="closing_summary_date">Closing Summary Date</label>
                  <input type="text" class="form-control" id="closing_summary_date" jDate/>
                </div>
              </div>

              <div class="col-4">
                <div class="form-group">
                  <label for="last_invoiced">Last Invoiced</label>
                  <input type="text" class="form-control" id="last_invoiced" jDate/>
                </div>
              </div>

              <div class="col-4">
                <div class="form-group">
                  <input type="checkbox" name="client_cms_flag_request" id="client_cms_flag_request">
                  <label for="client_cms_flag_request" class="ml-1">Client CMS Flag Request</label>
                </div>
              </div>

            </div>

            <div class="row">

              <div class="col-4">
                <div class="form-group">
                  <input type="checkbox" name="client_cms_flagged" id="client_cms_flagged">
                  <label for="client_cms_flagged" class="ml-1">Client CMS Flagged</label>
                </div>
              </div>
              <div class="col-4">
                <div class="form-group">
                  <label for="resonable_belief">Reasonable Belief</label>
                  <select type="text" class="form-control" id="reasonable_belief">
                    <option value="">Select Reasonable Belief</option>
                    <option value="yes">Yes</option>
                    <option value="no">No</option>
                  </select>
                </div>
              </div>

              <div class="col-4">
                <div class="form-group">
                  <label for="sfc_fd_1">SFC/FD-1</label>
                  <input type="file" class="form-control" name="sfc_fd_1" id="sfc_fd_1">
                </div>
              </div>
            </div>

            <div class="row">

              <div class="col-4">
                <div class="form-group">
                  <label for="lea_county">LEA County (DA/DOI)</label>
                  <input type="text" class="form-control" id="lea_county"/>
                </div>
              </div>

              <div class="col-4">
                <div class="form-group">
                  <label for="da_acknowledgement">DA Acknowledgement</label>
                  <input type="text" class="form-control" id="da_acknowledgement" jDate/>
                </div>
              </div>

              <div class="col-4">
                <div class="form-group">
                  <label for="da_request_date">DA Request Date</label>
                  <input type="text" class="form-control" id="da_request_date" jDate/>
                </div>
              </div>

            </div>

            <div class="row">
              <div class="col-4">
                <div class="form-group">
                  <label for="da_request_sent_back">DA Request Sent Back</label>
                  <input type="text" class="form-control" id="da_request_sent_back" jDate/>
                </div>
              </div>
              <div class="col-4">
                <div class="form-group">
                  <label for="da_declination_date">DA Declination Date</label>
                  <input type="text" class="form-control" id="da_declination_date" jDate/>
                </div>
              </div>

              <div class="col-4">
                <div class="form-group">
                  <label for="doi_acknowledgement">DOI Acknowledgement</label>
                  <input type="text" class="form-control" id="doi_acknowledgement" jDate/>
                </div>
              </div>

            </div>

            <div class="row">
              <div class="col-4">
                <div class="form-group">
                  <label for="cdi_case_number">CDI Case Number</label>
                  <input type="text" class="form-control" id="cdi_case_number"/>
                </div>
              </div>
              <div class="col-4">
                <div class="form-group">
                  <label for="doi_request_date">DOI Request Date</label>
                  <input type="text" class="form-control" id="doi_request_date" jDate/>
                </div>
              </div>

              <div class="col-4">
                <div class="form-group">
                  <label for="doi_request_sent_back">DOI Request Sent Back</label>
                  <input type="text" class="form-control" id="doi_request_sent_back" jDate/>
                </div>
              </div>

            </div>

            <div class="row">
              <div class="col-4">
                <div class="form-group">
                  <label for="doi_declination_date">DOI Declination Date</label>
                  <input type="text" class="form-control" id="doi_declination_date" jDate/>
                </div>
              </div>
              <div class="col-4">
                <div class="form-group">
                  <input type="checkbox" name="dr_in_progress" id="dr_in_progress">
                  <label for="dr_in_progress" class="ml-1">D/R in Progress</label>
                </div>
              </div>

              <div class="col-4">
                <div class="form-group">
                  <input type="checkbox" name="dr_to_lea" id="dr_to_lea">
                  <label for="dr_to_lea" class="ml-1">D/R to LEA</label>
                </div>
              </div>

            </div>

            <div class="row">
              <div class="col-4">
                <div class="form-group">
                  <label for="convicted">Convicted</label>
                  <select type="text" class="form-control" id="convicted">
                    <option value="">Select Convicted</option>
                    <option value="yes">Yes</option>
                    <option value="no">No</option>
                  </select>
                </div>
              </div>
              <div class="col-4">
                <div class="form-group">
                  <label for="restitution_awarded">Restitution Awarded</label>
                  <select type="text" class="form-control" id="restitution_awarded">
                    <option value="">Select Restitution Awarded</option>
                    <option value="yes">Yes</option>
                    <option value="no">No</option>
                  </select>
                </div>
              </div>

              <div class="col-4">
                <div class="form-group">
                  <label for="restitution_awarded_amount">Restitution Awarded Amount</label>
                  <input type="numeric" class="form-control" id="restitution_awarded_amount"/>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-4">
                <div class="form-group">
                  <label for="on_client_bill_review_tin_list">On Client Bill Review TIN list</label>
                  <select type="text" class="form-control" id="on_client_bill_review_tin_list">
                    <option value="">Select On Client Bill Review TIN list</option>
                    <option value="yes">Yes</option>
                    <option value="no">No</option>
                  </select>
                </div>
              </div>

              <div class="col-4">
                <div class="form-group">
                  <label for="br_flag_date">BR Flag Date</label>
                  <input type="text" class="form-control" id="br_flag_date" jDate/>
                </div>
              </div>
              <div class="col-4">
                <div class="form-group">
                  <label for="aka">AKA</label>
                  <input type="text" class="form-control" id="aka"/>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-4">
                <div class="form-group">
                  <label for="tin">TIN</label>
                  <input type="numeric" class="form-control" id="tin"/>
                </div>
              </div>

              <div class="col-4">
                <div class="form-group">
                  <label for="provider_name">Provider Name</label>
                  <input type="text" class="form-control" id="provider_name"/>
                </div>
              </div>
            </div>

          </form>
        </ng-container>
      </ng-container>

      <ng-container *ngIf="caseData?.clientInformation?.case_type?.name == 'Lien' || caseData?.clientInformation?.case_type?.name == 'SIU Claimant'">
        <div class="row my-3">
          <div class="col-12">
            <div class="card">
              <div class="card-header pt-1 pb-0">
                <b>Hearing Details</b>
              </div>
              <div class="card-body">
                <table
                  class="table small-text"
                >
                  <thead>
                    <tr>
                      <th class="border-0" scope="col" style="width: 15%;">
                        <b>DATE</b>
                      </th>
                      <th class="border-0" scope="col">TIME</th>
                      <th class="border-0" scope="col">VENUE</th>
                      <th class="border-0" scope="col">JUDGE</th>
                      <th class="border-0" scope="col">OUTCOME</th>
                      <th class="border-0" scope="col">ACTION</th>
                    </tr>
                  </thead>
                  <tbody>
                    <!-- <ng-container *ngIf="limosHearingList?.length">
                      <tr class="bg-white" *ngFor="let hearing of limosHearingList">
                        <td>
                          <input type="text"[(ngModel)]="hearing.hearing_date" class="form-control" jDate [disabled]="!hearing?.isEdit"/>
                        </td>
                        <td>
                          <input type="text"
                          [(ngModel)]="hearing.hearing_time"
                          class="form-control"
                          [disabled]="!hearing?.isEdit"
                          mask="00:00:00"
                          (keyup)="checkTimeValidation(hearing,$event.target.value)"
                          />
                        </td>
                        <td>
                          <input type="text" [(ngModel)]="hearing.hearing_venue" class="form-control" [disabled]="!hearing?.isEdit"/>
                        </td>
                        <td>
                          <input type="text" [(ngModel)]="hearing.judge" class="form-control" [disabled]="!hearing?.isEdit"/>
                        </td>
                        <td>
                          <input type="text" [(ngModel)]="hearing.outcome" class="form-control" [disabled]="!hearing?.isEdit"/>
                        </td>
                        <td>
                          <div class="d-flex">
                            <button
                              class="icon-button mr-2"
                              id="enable-edit-adjuster-save1"
                              (click)="hearing.isEdit = true"
                              *ngIf="!hearing?.isEdit"
                            >
                              <em class="fa fas fa-pencil"></em>
                            </button>
                            <button class="icon-button" (click)="hearing.isEdit = false" *ngIf="hearing?.isEdit">
                              <em class="fa fas fa-close"></em>
                            </button>
                            <button
                            *ngIf="hearing?.isEdit"
                              class="icon-button mr-2"
                              (click)="updateLimosHearing(hearing)"
                              [disabled]="hearing?.isInValid"
                            >
                              <em class="fa fas fa-check"></em>
                            </button>
                          </div>
                        </td>
                      </tr>
                    </ng-container> -->

                    <tr class="bg-white" [formGroup]="hearingDataForm">
                      <td>
                        <input type="text" class="form-control" jDate [formCtrl]="hearingDataForm.get('hearing_date')">
                      </td>
                      <td>
                        <input
                          type="text"
                          name="time_spent"
                          id="time_spent"
                          class="form-control text-center"
                          mask="00:00:00"
                          placeholder="hh:mm:ss"
                          formControlName="hearing_time"
                          (keyup)="hearingDataForm.get('hearing_time').setValue($event.target.value)"
                        />
                      </td>
                      <td>
                        <input type="text" class="form-control" formControlName="hearing_venue">
                      </td>
                      <td>
                        <input type="text" class="form-control" formControlName="judge">
                      </td>
                      <td>
                        <select class="form-control" formControlName="outcome">
                          <option value="">Select</option>
                          <option value="OTOC">OTOC</option>
                          <option value="Withdrawal">Withdrawal</option>
                          <option value="WCAB">WCAB</option>
                        </select>
                      </td>
                      <td class="d-flex justify-content-center align-items-center" style="height: 50px;">
                        <button
                          class="icon-button"
                          id="add-new-hearing-btn"
                          title="Save"
                          (click)="saveLimosHearingData()"
                          [disabled]="hearingDataForm.invalid"
                        >
                          <em class="fa fas fa-plus"></em>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </ng-container>

      <div class="row">
        <div class="col-12 mt-4 d-flex justify-content-end">
          <button type="button" class="btn btn-outline-secondary btn-sm text-dark mr-1">
            Cancel
          </button>
          <button type="button" class="btn spear-button-background btn-sm text-white" (click)="onSubmitForm()">
            Save & Continue
          </button>
        </div>
      </div>



    </ng-container>

  </div>
</div>